type HistoryGuard = (event: PopStateEvent) => void;

let activeGuard: HistoryGuard | null = null;

export function setProfileHistoryGuard(guard: HistoryGuard) {
  activeGuard = guard;
  return () => {
    if (activeGuard === guard) activeGuard = null;
  };
}

export function listenForProfileHistory() {
  const dispatch = (event: PopStateEvent) => activeGuard?.(event);
  window.addEventListener("popstate", dispatch, true);
  return () => window.removeEventListener("popstate", dispatch, true);
}
